import { SelectPackageForm } from "@/components/forms/easi-recharge/select-package-form";

export default function EasiRechargeSelectPackage() {
  return (
    <div className="space-y-12">
      <SelectPackageForm className="space-y-12" />
    </div>
  );
}
